import { IRRESISTIBLE_OFFENSE, hasEpicBoon, overwhelmingStrikeAbility } from '../../../../shared/rules/epicBoons.mjs';
import { calculateAbilityScore } from '../../utils/derivedStats';

// 2024 Boon of Irresistible Offense, Overwhelming Strike: when you roll a 20 on the d20 for an attack roll, deal extra
// damage equal to the ability score the boon increased, of the attack's type. It is never worse to take, so it applies
// automatically and has no usage limit. (Overcome Defenses is applied by the shared damage-trait rule.)
export const OVERWHELMING_STRIKE_FEATURE_ID = 'feat:boon-of-irresistible-offense';
export const hasIrresistibleOffense = (character) => hasEpicBoon(character, IRRESISTIBLE_OFFENSE);

const ineligible = (reasonCode) => ({ status: 'ineligible', featureId: OVERWHELMING_STRIKE_FEATURE_ID, featureLabel: 'Overwhelming Strike', reasonCode });

export const evaluateOverwhelmingStrike = (context) => {
  if (context?.roll?.naturalRoll !== 20) return ineligible('not-natural-20');
  const ability = overwhelmingStrikeAbility(context.attacker?.entity);
  if (!ability) return ineligible('no-boon-ability');
  const score = calculateAbilityScore(context.attacker.entity, ability);
  return {
    status: 'automatic',
    featureId: OVERWHELMING_STRIKE_FEATURE_ID,
    featureLabel: 'Overwhelming Strike',
    reasonCode: 'natural-20',
    components: [{ id: OVERWHELMING_STRIKE_FEATURE_ID, label: 'Overwhelming Strike', source: { type: 'feature', featureId: OVERWHELMING_STRIKE_FEATURE_ID },
      flat: score, damageType: { mode: 'inherit' }, critical: { dice: 'unchanged' } }],
    claims: [],
  };
};
